import {LeadAvatar} from '../../avatar/lead-avatar';

import {BaseRow} from '../base-row/base-row';

import {LeadRowContent} from './lead-row-content';
import type {RelatedEntity} from './types';

interface Props {
    title: string;
    onClick: () => void;
    assignee: RelatedEntity | null | undefined;
    relatedAccount: RelatedEntity | null | undefined;
    relatedContact: RelatedEntity | null | undefined;
    value: string | null | undefined;
    status: string;
    avatarUrl: string;
}

export function LeadRow(props: Props) {
    return (
        <BaseRow
            type='leads'
            onClick={props.onClick}
            title={props.title}
            customIcon={<LeadAvatar avatarUrl={props.avatarUrl} status={props.status} size={24} />}
        >
            <LeadRowContent
                status={props.status}
                assignee={props.assignee}
                relatedAccount={props.relatedAccount}
                relatedContact={props.relatedContact}
                value={props.value}
            />
        </BaseRow>
    );
}
